import * as React from "react";
import { makeStyles, useId, Button, tokens } from "@fluentui/react-components";
import { IAuthRequest } from "../../interfaces/IAuthenticate";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FieldInput } from "../common/FieldInput";
import { useAuth } from "../../authentication/AuthContextProvider";
import { DataContext } from "../../context/DataContext";
import { useContext } from "react";
const useStyles = makeStyles({
  formWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: tokens.spacingVerticalM,
    padding: "40px",
    maxWidth: "400px",
  },
  text: {
    font: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase600,
  },
  button: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralBackground1,
    font: tokens.fontFamilyBase,
  },
});

export const LoginForm = (): JSX.Element => {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const auth = useAuth();
  const emailId = useId("input-email");
  const passwordId = useId("input-password");
  const largeId = useId("input-large");
  const styles = useStyles();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IAuthRequest>();

  const onSubmit = (data: IAuthRequest) => {
    auth.login(data, dataContext);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.formWrapper}>
        <div className={styles.form}>
          <text className={styles.text}>{"Kundportalen"}</text>
          <FieldInput
            name={"username"}
            label={t("labels.email")}
            type={"email"}
            inputId={emailId}
            inputSizeId={largeId}
            required={true}
            register={register}
            errors={errors.username}
          />
          <FieldInput
            name={"password"}
            label={t("labels.password")}
            type={"password"}
            inputId={passwordId}
            inputSizeId={largeId}
            required={true}
            register={register}
            errors={errors.password}
          />
        </div>
        <Button
          appearance="primary"
          type="submit"
          className={styles.button}
          size="large"
          disabled={dataContext.state.isLoading}
        >
          {t("buttons.login")}
        </Button>
      </div>
    </form>
  );
};
